import { render } from "./PantryFoodCheckItem.vue?vue&type=template&id=0d78e6b0&ts=true"
import script from "./PantryFoodCheckItem.vue?vue&type=script&lang=ts"
export * from "./PantryFoodCheckItem.vue?vue&type=script&lang=ts"

import "./PantryFoodCheckItem.vue?vue&type=style&index=0&id=0d78e6b0&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__